import { render, staticRenderFns } from "./StatisticView.vue?vue&type=template&id=b54a7374&"
import script from "./StatisticView.vue?vue&type=script&lang=js&"
export * from "./StatisticView.vue?vue&type=script&lang=js&"
import style0 from "./StatisticView.vue?vue&type=style&index=0&id=b54a7374&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports